/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type Shot_status = "COMPLETED" | "FAILED" | "PENDING" | "PROCESSING" | "%future added value";
export type TourShotsGridRegenerateMutationVariables = {
    shotId: string;
};
export type TourShotsGridRegenerateMutationResponse = {
    readonly regenerateShot: {
        readonly shot: {
            readonly id: string;
            readonly shotStatus: Shot_status;
            readonly enhancedImageURI: string;
            readonly errorMessage: string;
        };
    };
};
export type TourShotsGridRegenerateMutation = {
    readonly response: TourShotsGridRegenerateMutationResponse;
    readonly variables: TourShotsGridRegenerateMutationVariables;
};



/*
mutation TourShotsGridRegenerateMutation(
  $shotId: ID!
) {
  regenerateShot(input: {shotId: $shotId}) {
    shot {
      id
      shotStatus
      enhancedImageURI
      errorMessage
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shotId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "shotId",
            "variableName": "shotId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RegenerateShotPayload",
    "kind": "LinkedField",
    "name": "regenerateShot",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Shot",
        "kind": "LinkedField",
        "name": "shot",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shotStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enhancedImageURI",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TourShotsGridRegenerateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TourShotsGridRegenerateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e96e21f86414161950f39cd33e29be53",
    "id": null,
    "metadata": {},
    "name": "TourShotsGridRegenerateMutation",
    "operationKind": "mutation",
    "text": "mutation TourShotsGridRegenerateMutation(\n  $shotId: ID!\n) {\n  regenerateShot(input: {shotId: $shotId}) {\n    shot {\n      id\n      shotStatus\n      enhancedImageURI\n      errorMessage\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '45009ba465c96dc3e81613d23b15bca5';
export default node;
